<form [formGroup]="formGroup()">
  <div class="flex items-center gap-1">
    <p-checkbox
      [formControl]="formGroup().controls.isBankAccount"
      [binary]="true"
      [inputId]="'isBankAccount'"
      styleClass="customCheckbox"
    />
    <label [for]="'isBankAccount'" class="ml-2 my-4"
      >Czy dane konta bankowego</label
    >
  </div>
  <div class="flex flex-col gap-10">
    <div class="flex flex-col gap-4" [formGroup]="formGroup()">
      @for (element of isForeignRadioElements; track element.key) {
        <div class="field-checkbox">
          <span
            [pTooltip]="
              element.key && formGroup().controls.isForeign.disabled
                ? 'Numer konta bankowego w państwie UE/EFTA albo Wielkiej Brytanii może być podany, jeżeli Adres zamieszkania jest adresem zagranicznym.'
                : ''
            "
            tooltipPosition="top"
            [showDelay]="200"
            [hideDelay]="200"
          >
            <p-radio-button
              variant="filled"
              [inputId]="element.key"
              [value]="element.key"
              [formControl]="formGroup().controls.isForeign"
              styleClass="customRadioButton"
            />
          </span>
          <label [for]="element.key" class="ml-2">{{ element.label }}</label>
        </div>
      }
    </div>
    <div>
      @if (formGroup().controls.isForeign.value) {
        <app-form-foreign-bank-account
          [formGroup]="formGroup().controls.foreignAccount"
        ></app-form-foreign-bank-account>
      } @else {
        <app-form-domestic-bank-account
          [formGroup]="formGroup().controls.domesticAccount"
        ></app-form-domestic-bank-account>
      }
    </div>
  </div>
</form>
